export const COMPARE_GROUPS = {
  FILE: "File",
  CLASSIFICATION: "Classification",
  // Where a sample came from and who has seen it: first and last seen in the
  // cloud, first seen locally, source and comment counts.
  PROVENANCE: "Provenance",
  TAGS: "Tags and capabilities"
} as const;
